import { useEffect } from 'react'

export const useInvoiceSentNotification = (
  didInvoiceSentSuccesfully,
  setDialogVisibility
) => {
  useEffect(() => {
    if (didInvoiceSentSuccesfully) {
      setDialogVisibility('invoiceSent', true)
      setDialogVisibility('billingContacts', false)
    }
  }, [didInvoiceSentSuccesfully, setDialogVisibility])
}
